import { Form } from '@melio/penny';
export const TaxIdField = (props: React.ComponentProps<typeof Form.TextField>) => (
  <Form.TextField
    {...props}
    maskProps={{
      mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    }}
  />
);
